<template>
    <section>
        <h1 class="text-2xl font-bold tracking-tight text-slate-900 mb-4">
          Configurations
        </h1>
        <div class="container mx-auto p-2 sm:px-4 lg:p-4 bg-white rounded-lg">
            <nav class="mb-2" aria-label="breadcrumb">
                <ol
                class="flex"
                >
                <!-- // font-bold -->
                <li
                  v-for="(config, index) in adminConfig"
                  :key="index"
                  class="px-2 cursor-pointer"
                  :class="config.configuration_name === activeConfig.configName ? 'font-bold' : ''"
                >
                  {{ config.display_name }}
                </li>
                </ol>
            </nav>
            <nav aria-label="breadcrumb">
                <ol
                class="flex divide-x divide-indigo-400"
                >
                <!-- // font-bold -->
                <li
                  v-for="(subConfig, subIndex) in selectedSubConfig"
                  :key="subIndex"
                  class="px-2 text-sm cursor-pointer"
                  :class="subConfig.sub_config_name === activeSubConfig.subConfigName ? 'font-bold' : ''"
                  @click="subConfigChangehandler(subConfig)"
                >
                  {{ subConfig.display_name }}
                </li>
                </ol>
            </nav>
        </div>
        <AdminConfigData
          v-if="!configDetailsDisplay"
          :configData="adminConfigData"
          :activeSubConfig="activeSubConfig"
          :getAdminConfigFromStore="getAdminConfigFromStore"
          :handlePageChange="handlePageChange"
          @configDetails="handleConfigDetails($event)"
          @newConfigDetails="handleNewConfigDetails"
        ></AdminConfigData>
        <AdminConfigDetails
          v-else
          :toggleConfigDetailsDisplay="toggleConfigDetailsDisplay"
          :getAdminConfigFromStore="getAdminConfigFromStore"
          :operation="operation"
          :dataDetails="dataDetails"
        ></AdminConfigDetails>
    </section>
</template>
<script>
import { mapGetters} from "vuex";
import AdminConfigData from "./AdminConfigData.vue";
import AdminConfigDetails from "./AdminConfigDetails.vue";
export default {
  name: "AdminConfiguration",
  data () {
    return {
      activeConfig: {
        configId: null,
        configName: null
      },
      activeSubConfig: {
        subConfigId: null,
        subConfigName: null,
        displayName: null
      },
      configDetailsDisplay: false,
      operation: null,
      dataDetails: null
    }
  },
  components: {
    AdminConfigData,
    AdminConfigDetails
},
  computed: {
    ...mapGetters(['adminConfig', 'adminConfigData']),
    selectedSubConfig () {
      let config = this.adminConfig && this.adminConfig.length && this.adminConfig.find((itm) => {
        return itm.configuration_name === this.activeConfig['configName']
      })
      return config && config.sub_config
    }
  },
  created () {
    this.adminConfig && this.adminConfig.length ? this.getAdminConfigFromStore() : this.$store.dispatch('getAdminConfig')
  },
  watch: {
    adminConfig () {
      if (this.adminConfig && this.adminConfig.length) {
        this.activeConfig['configName'] = this.adminConfig[0].configuration_name;
        this.activeConfig['configId'] = this.adminConfig[0].id;
      }
    },
    'activeConfig': {
      handler () {
        if (this.selectedSubConfig && this.selectedSubConfig.length) {
          this.activeSubConfigHandler(this.selectedSubConfig[0])
        }
      },
      deep: true
    },
    'activeSubConfig': {
      handler () {
        //on subconfig selection get data listing
        if (this.activeSubConfig && this.activeSubConfig.subConfigName && this.activeSubConfig.subConfigName.length) {
          this.getConfigDataHandler({page: 1})
        }
      },
      deep: true
    }
  },
  methods: {
    async handlePageChange (page) {
      await this.getConfigDataHandler({page: page})
    },
    async getConfigDataHandler (query){
      this.$store.dispatch('getAdminConfigData', {
        ...query,
        config: this.activeConfig['configId'],
        subConfig: this.activeSubConfig['subConfigId']
      })
    },
    async subConfigChangehandler (subConfig) {
      this.activeSubConfigHandler(subConfig)
      if (this.configDetailsDisplay) {
        this.toggleConfigDetailsDisplay()
      }
    },
    getAdminConfigFromStore () {
      const data = this.adminConfig
      const subConfigData = {...this.activeSubConfig}
      this.$store.commit('setAdminConfig', [])
      this.activeSubConfigHandler({
        sub_config_name: null,
        id: null,
        display_name: null
      })
      this.$store.commit('setAdminConfig', data)
      this.activeSubConfigHandler({
        sub_config_name: subConfigData.subConfigName,
        id: subConfigData.subConfigId,
        display_name: subConfigData.displayName
      })
    },
    activeSubConfigHandler(subConfig) {
      this.activeSubConfig['subConfigName'] = subConfig.sub_config_name;
      this.activeSubConfig['subConfigId'] = subConfig.id;
      this.activeSubConfig['displayName'] = subConfig.display_name;
    },
    toggleConfigDetailsDisplay () {
      this.configDetailsDisplay = !this.configDetailsDisplay
    },
    handleConfigDetails (dataObj) {
      dataObj && Object.keys(dataObj).length ? this.configOperationHandler('edit') : this.configOperationHandler('add')
      this.dataDetails = {
        activeConfig: this.activeConfig,
        activeSubConfig: this.activeSubConfig,
        ...dataObj
      }
      this.toggleConfigDetailsDisplay()
    },
    handleNewConfigDetails () {
      this.handleConfigDetails({})
    },
    configOperationHandler (opName) {
      this.operation = opName
    }
  }
}
</script>